const Events = {
    LOADING_INITIATED: 'api_loading_initiated',
    LOADING_COMPLETED: 'api_loading_completed',
    APPLICATION_LOGOUT:'app_logout'
}

export default Events;
